import rampColor from '../utils/map/ramp-color';

const serviceCoverageRamp = [[255, 255, 255], [21, 84, 232]];
const competitionRamp = [[255, 255, 255], [0, 109, 44]];
const providersRamp = [[255, 255, 255], [160, 133, 0]];
const maximumServiceRamp = [[255, 255, 255], [84, 39, 143]];
const internetSubRamp = [[255, 255, 255], [8, 191, 2]];
const householdIncomeRamp = [[255, 255, 255], [184, 0, 0]];
const raceRamp = [[255, 255, 255], [97, 0, 92]];
const ageRamp = [[255, 255, 255], [252, 79, 5]];

const fillOpacity = 0.65;
const strokeOpacity = 1;

const getColor = (ramp, index, count, alpha) => {
  const c = rampColor(ramp, (index - 1) / (count - 1));
  return [...c, alpha];
};

export const themeConfig = {
  'Service Coverage 25/3': {
    theme: 'Service Coverage 25/3',
    field: 'location_served_25x3_pct',
    title: 'Locations with at least 25/3 Mbps service',
    ramp: [
      { label: 'None', max: 0, fillColor: getColor(serviceCoverageRamp, 1, 5, fillOpacity) },
      { label: '<80%', min: 0, max: 0.80, fillColor: getColor(serviceCoverageRamp, 2, 5, fillOpacity) },
      { label: '80% - 90%', min: 0.80, max: 0.90, fillColor: getColor(serviceCoverageRamp, 3, 5, fillOpacity) },
      { label: '90% - 99%', min: 0.90, max: 0.99, fillColor: getColor(serviceCoverageRamp, 4, 5, fillOpacity) },
      { label: '>99%', min: 0.99, fillColor: getColor(serviceCoverageRamp, 5, 5, fillOpacity) },
    ],
    strokeColor: [...serviceCoverageRamp[1], strokeOpacity],
  },
  'Service Coverage 100/20': {
    theme: 'Service Coverage 100/20',
    field: 'location_served_100x20_pct',
    title: 'Locations with at least 100/20 Mbps service',
    ramp: [
      { label: 'None', max: 0, fillColor: getColor(serviceCoverageRamp, 1, 5, fillOpacity) },
      { label: '<80%', min: 0, max: 0.80, fillColor: getColor(serviceCoverageRamp, 2, 5, fillOpacity) },
      { label: '80% - 90%', min: 0.80, max: 0.90, fillColor: getColor(serviceCoverageRamp, 3, 5, fillOpacity) },
      { label: '90% - 99%', min: 0.90, max: 0.99, fillColor: getColor(serviceCoverageRamp, 4, 5, fillOpacity) },
      { label: '>99%', min: 0.99, fillColor: getColor(serviceCoverageRamp, 5, 5, fillOpacity) },
    ],
    strokeColor: [...serviceCoverageRamp[1], strokeOpacity],
  },
  Competition: {
    theme: 'Competition',
    field: 'location_providers_2plus_100x20_pct',
    title: 'Locations with two or more 100/20 Mbps providers',
    ramp: [
      { label: 'None/one provider', max: 0, fillColor: getColor(competitionRamp, 1, 5, fillOpacity) },
      { label: '<25%', min: 0, max: 0.25, fillColor: getColor(competitionRamp, 2, 5, fillOpacity) },
      { label: '25% - 50%', min: 0.25, max: 0.5, fillColor: getColor(competitionRamp, 3, 5, fillOpacity) },
      { label: '50% - 75%', min: 0.5, max: 0.75, fillColor: getColor(competitionRamp, 4, 5, fillOpacity) },
      { label: '>75%', min: 0.75, fillColor: getColor(competitionRamp, 5, 5, fillOpacity) },
    ],
    strokeColor: [...competitionRamp[1], strokeOpacity],
  },
  'Number of Providers': {
    theme: 'Number of Providers',
    field: 'total_providers',
    title: 'Number of providers',
    ramp: [
      { label: '0', max: 0, fillColor: getColor(providersRamp, 1, 5, fillOpacity) },
      { label: '1', min: 0.5, max: 1, fillColor: getColor(providersRamp, 2, 5, fillOpacity) },
      { label: '2', min: 1.5, max: 2, fillColor: getColor(providersRamp, 3, 5, fillOpacity) },
      { label: '3', min: 2.5, max: 3, fillColor: getColor(providersRamp, 4, 5, fillOpacity) },
      { label: '4+', min: 3.5, max: 30, fillColor: getColor(providersRamp, 5, 5, fillOpacity) },
    ],
    strokeColor: [...providersRamp[1], strokeOpacity],
  },
  'Maximum Speed': {
    theme: 'Maximum Speed',
    field: 'served_max',
    title: 'Maximum speed available (down/up)',
    unique: {
      default: { label: 'None', fillColor: getColor(maximumServiceRamp, 1, 5, fillOpacity) },
      '25x3': { label: '25/3 Mbps', fillColor: getColor(maximumServiceRamp, 2, 5, fillOpacity) },
      '100x20': { label: '100/20 Mbps', fillColor: getColor(maximumServiceRamp, 3, 5, fillOpacity) },
      '100x100': { label: '100/100 Mbps', fillColor: getColor(maximumServiceRamp, 4, 5, fillOpacity) },
      '1000x1000': { label: '1/1 Gbps', fillColor: getColor(maximumServiceRamp, 5, 5, fillOpacity) },
    },
    strokeColor: [...maximumServiceRamp[1], strokeOpacity],
  },
  // 'Federal Funding': {
  //   theme: 'Federal Funding',
  //   field: 'funding',
  //   title: 'Federal Funding Awarded',
  //   unique: {
  //     Y: { label: 'Yes', fillColor: [160, 160, 160, fillOpacity] },
  //     default: { label: 'No', fillColor: [223, 223, 223, fillOpacity] },
  //   },
  //   strokeColor: [...maximumServiceRamp[1], strokeOpacity],
  // },
};

export const demographicColorRamps = {
  'Internet Subscriptions': {
    colorRamp: [
      `rgba(${getColor(internetSubRamp, 1, 5, fillOpacity)})`,
      `rgba(${getColor(internetSubRamp, 2, 5, fillOpacity)})`,
      `rgba(${getColor(internetSubRamp, 3, 5, fillOpacity)})`,
      `rgba(${getColor(internetSubRamp, 4, 5, fillOpacity)})`,
      `rgba(${getColor(internetSubRamp, 5, 5, fillOpacity)})`,
    ],
  },
  'Household Income': {
    colorRamp: [
      `rgba(${getColor(householdIncomeRamp, 1, 5, fillOpacity)})`,
      `rgba(${getColor(householdIncomeRamp, 2, 5, fillOpacity)})`,
      `rgba(${getColor(householdIncomeRamp, 3, 5, fillOpacity)})`,
      `rgba(${getColor(householdIncomeRamp, 4, 5, fillOpacity)})`,
      `rgba(${getColor(householdIncomeRamp, 5, 5, fillOpacity)})`,
    ],
  },
  Race: {
    colorRamp: [
      `rgba(${getColor(raceRamp, 1, 7, fillOpacity)})`,
      `rgba(${getColor(raceRamp, 2, 7, fillOpacity)})`,
      `rgba(${getColor(raceRamp, 3, 7, fillOpacity)})`,
      `rgba(${getColor(raceRamp, 4, 7, fillOpacity)})`,
      `rgba(${getColor(raceRamp, 5, 7, fillOpacity)})`,
      `rgba(${getColor(raceRamp, 6, 7, fillOpacity)})`,
      `rgba(${getColor(raceRamp, 7, 7, fillOpacity)})`,
    ],
  },
  Age: {
    colorRamp: [
      `rgba(${getColor(ageRamp, 1, 5, fillOpacity)})`,
      `rgba(${getColor(ageRamp, 2, 5, fillOpacity)})`,
      `rgba(${getColor(ageRamp, 3, 5, fillOpacity)})`,
      `rgba(${getColor(ageRamp, 4, 5, fillOpacity)})`,
      `rgba(${getColor(ageRamp, 5, 5, fillOpacity)})`,
    ],
  },
};
